<template>
  <q-dialog v-model="shown">
    <q-card style="width: 530px;">
      <q-card-section class="row items-center q-mx-xs">
        <div class="text-h6">
          Assign Card
        </div>
        <q-space />
        <q-btn
          v-close-popup
          icon="close"
          flat
          round
          dense
        />
      </q-card-section>
      <q-card-section>
        <q-input
          v-model="uid"
          label="Card Barcode"
          :rules="[val => !!val || 'Card Barcode is required']"
          bottom-slots
        />
        <q-inner-loading :showing="saving" />
      </q-card-section>
      <q-card-actions class="row justify-between q-ma-sm">
        <q-btn
          v-show="!saving"
          class="col"
          label="Assign Card"
          color="primary"
          size="lg"
          :disable="!uid"
          @click="save"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>

import Card from 'src/models/card/Card'

export default {
  name: 'AssignCardDialog',
  props: {
    user: {
      type: Object,
      required: false,
      default: null
    }
  },
  emits: ['close'],
  data () {
    return {
      shown: false,
      saving: false,
      uid: null
    }
  },
  watch: {
    shown () {
      if (!this.shown) {
        this.$emit('close')
        this.uid = null
      }
    }
  },
  methods: {
    show () {
      this.shown = true
    },
    async save () {
      this.saving = true

      if (!this.uid) return

      this.user.card = new Card({ uid: this.uid })
      await this.user.save()
      this.saving = false
      this.shown = false
    }
  }
}

</script>

<style lang="scss" scoped>
</style>
